import { createContext, PropsWithChildren, useContext, useState } from 'react'

export type DeviceStatusDataType = {
  id: number
  title: string
  parameter: string
  output: boolean
  brightness?: number
}

const DeviceStatusContext = createContext<{
  deviceStatusData: DeviceStatusDataType[]
  setDeviceStatusData: React.Dispatch<React.SetStateAction<DeviceStatusDataType[]>>
}>({
  deviceStatusData: [],
  setDeviceStatusData: () => null,
})

export const useDeviceStatusContext = () => {
  return useContext(DeviceStatusContext)
}

export const DeviceStatusContextProvider = ({ children }: PropsWithChildren<unknown>) => {
  const [deviceStatusData, setDeviceStatusData] = useState<DeviceStatusDataType[]>([])

  return (
    <DeviceStatusContext.Provider
      value={{
        deviceStatusData,
        setDeviceStatusData,
      }}
    >
      {children}
    </DeviceStatusContext.Provider>
  )
}

export default DeviceStatusContext
